<template>
    <div class="spinner">
        <div style="display:flex; justify-content:center; padding:40px">
             <a-spin :spinning="loading" tip="Authorizing..." />
        </div>
        <div style="display:flex; justify-content:center; padding:40px">
            
             <h3 style="margin-left: 10px;color:blue">Please kindly wait...</h3>
        </div>
       
    </div>
</template>

<script>
import { mapActions } from 'vuex';
    export default {
        name:"AccountVerification",
        data(){
            return {
                loading: false,
                token:""
            }
        },
        methods:{
            ...mapActions(['checkValidTokenAsync','getAgentProfile']),
            checkValidToken(){
                //  console.log("token verification | ", response)
                this.loading = true;
                this.token = this.$route.query.Token
               
                 this.checkValidTokenAsync(this.token).then(response => {
                    //  console.log("token verification | ", response)
                    this.loading = false;
                    if(response.status === 200){
                        this.getAgentProfile().then(response => {
                            this.loading = false;
                            if(response.status ==200){
                                this.showSuccessAlert("Account Verified Successfully!")
                                this.$router.push(`/entry`).catch(()=>{});
                            }else{
                                this.loading = false
                                // console.log("Error | ", response)
                                this.showErrorAlert(`Something went wrong,try again later`)
                                this.$router.push(`/welcome`).catch(()=>{});
                            }
                        }, error =>{
                            this.loading = false
                            console.log("Error | ", error)
                            this.showErrorAlert(`Something went wrong, try again later`)
                            this.$router.push(`/welcome`).catch(()=>{});
                        })
                        
                    }else{
                        this.loading = false;
                        this.showErrorAlert('Something went wrong, try again later')
                        this.$router.push(`/welcome`).catch(()=>{});
                    }
                },
                error =>{
                        this.loading = false
                        this.showErrorAlert('Something went wrong,try again later')
                        console.loading("Error | ", error)
                        this.$router.push(`/welcome`).catch(()=>{});
                })
            },
            showSuccessAlert(message) {
                this.$notification['success']({
                    message: message,
                });
            },
            showErrorAlert(message) {
                this.$notification['error']({
                    message: message
                });
            },
        },
        created(){
            if(this.checkValidToken){
                this.checkValidToken()
            }
            
        }

    }
</script>

<style scoped>
.spinner {
  text-align: center;
  border-radius: 4px;
  margin-bottom: 20px;
  padding: 30px 50px;
  margin: 20px 0;
}

.spinner >>> .ant-spin-dot-item {
    background-color: #418a49;
}
</style>